import React from "react";
import validation from "./Validation";
import {
  InputLabelErrorTextStyle,
  InputLabelErrorIconStyle,
  InputLabelErrorAlertCicleStyle,
  InputLabelErrorMainStyle,
} from "../styles/InputStyle";
import { LuAlertCircle } from "react-icons/lu";

interface InputThousandSeparatorProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string;
  handleValue: (value: string) => void;
  alt: string;
  className: string;
  label: string;
  error: string;
  validators: any;
  allowComma: boolean;
}

function InputThousandSeparator(props: InputThousandSeparatorProps) {
  const addPoints = (num: string) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num: string) =>
    num.toString().replace(props.allowComma ? /[^0-9,]/g : /[^0-9]/g, "");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    var str = event.target.value;
    // eslint-disable-next-line
    if (str.match(/\,/g)?.length! > 1) {
      str = str.substring(0, str.length-1);
    }
    props.handleValue(addPoints(removeNonNumeric(str)));
  }

  return (
    <div className={props.className}>
      <label className={props.className + "-label"}>{props.label}</label>
      <input
        className={props.className + "-grey"}
        type="text"
        value={props.value}
        onInput={handleChange}
      />
      <label
        className={props.className + '-error'}
        style={InputLabelErrorMainStyle}
      >
      {props.error && (
        <div
          className={props.className + "-error"}
          style={InputLabelErrorTextStyle}
        >
          <div
            className={props.className + "-alert-icon"}
            style={InputLabelErrorIconStyle}
          >
            <LuAlertCircle
              className={props.className + "-alert-circle"}
              style={InputLabelErrorAlertCicleStyle}
            />
          </div>
          {props.error}
        </div>
      )}
      </label>
    </div>
  );
}

const InputThousandSeparatorValidated = validation(InputThousandSeparator);

export default InputThousandSeparatorValidated;
